import { useContextStore } from '@/store/modules/context/store.ts';
import { useUserStore } from '@/store/modules/user/store.js';

export default {
    accountsList: (state) => Object.values(state.accounts),
    getAccountById: (state) => (id) => state.accounts[id] || null,
    contextIsChildAccount: (state) =>
        !!state.contextAccount && !state.contextAccount.account_manager,
    contextAccountId: (state) => state.contextAccount?.id || null,

    childAccount: (state) => {
        const lead = useContextStore().lead;
        let account = state.contextAccount;
        const leadAccountMatchContextAccount =
            lead?.id && account?.id && account.id == lead.account_id;

        if (!leadAccountMatchContextAccount) {
            account =
                state.contextAccount?.children.find((child) => child.id == lead.account_id) ||
                state.contextAccount;
        }

        if (account?.id) {
            return account;
        }

        return useUserStore().authUser?.account;
    },
};
